import React, { useContext } from "react";
import PropTypes from "prop-types";
import ColumnHidingContext from "./ColumnHiding/Context";

// TODO: Change to render a styled.col with a `width` CSS property based on the
// size when column sizing is implemented.

/** Represents a column in a column group. */
import { jsx as _jsx } from "react/jsx-runtime";
export default function Col(_ref) {
  let {
    id,
    noSorting,
    ...props
  } = _ref;
  /**
   * Including this do-nothing expression is one way of avoiding the eslint
   * "no-unused-vars" while still pulling it out of `props`.
   */
  noSorting;
  const {
    hiddenColumns
  } = useContext(ColumnHidingContext);

  // Add `hidden` attribute if needed. This is because the Table styling
  // is based on the [hidden] attributes
  return /*#__PURE__*/_jsx("col", {
    hidden: hiddenColumns.includes(id),
    ...props,
    id: id
  });
}
Col.propTypes = {
  /** A unique identifier for the column. This is required if a `<ColumnHiding>` anscestor is present. It also renders as the `id` attribute, so it must be unique on the page. */
  id: PropTypes.string,
  /** When used with a `<Sorting>` ancestor, this column will not be sortable. */
  noSorting: PropTypes.bool
};